import React, { Suspense, memo } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';
import About from '../components/About';
import Footer from '../components/Footer';
import AgeVerification from '../components/AgeVerification';
import CookieConsent from '../components/CookieConsent';

// Lazy load components that are below the fold on mobile
const Guides = React.lazy(() => import('../components/Guides'));
const FAQ = React.lazy(() => import('../components/FAQ'));
const News = React.lazy(() => import('../components/News'));
const Contact = React.lazy(() => import('../components/Contact'));

// Optimized loading fallback component for lazy-loaded sections
const SectionSkeleton = memo(() => (
  <div className="animate-pulse">
    <div className="h-64 bg-gray-200 rounded-lg"></div>
  </div>
));

const Home = () => {
  return (
    <div className="min-h-screen bg-book-cream initial-render" itemScope itemType="https://schema.org/WebSite">
      <meta itemProp="name" content="Brit Ember" />
      <meta itemProp="url" content="https://britember.com" />
      <meta itemProp="description" content="UK's premier casino aggregator providing expert reviews, guides, and comparisons of licensed gaming platforms including PUB, NRG, and Mr. Play." />
      <Header />
      <Hero />
      <Offers />
      <About />
      <Suspense fallback={<SectionSkeleton />}>
        <Guides />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <FAQ />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <News />
      </Suspense>
      <Suspense fallback={<SectionSkeleton />}>
        <Contact />
      </Suspense>
      <Footer />
      <AgeVerification />
      <CookieConsent />
    </div>
  );
};

export default Home;
